/* Màn 4 — Lịch hẹn (cùng bảng lịch dùng chung, bộ lọc "lh" — R36) */
import React from 'react';

import { StoreCtx, useStore } from './components/Store';

import Layout from '../../Layout'
import { SoftBar } from './components/SoftBar';
import TeleDrawer from './components/TeleDrawer';
import { Helmet } from 'react-helmet-async';

import { Cap, Demo, DT, Note, TXT_LATE, TXT_OK, type WCol } from './components/UI';
import { Card } from 'antd';
import type { LichRow } from './components/Types';
import { CUS, LICH } from './components/Data';
import { NameLink } from './components/Common';

const stCell = (s: string) =>
  /Không đến|Chưa xác nhận|Chờ cọc/.test(s) ? <span className={TXT_LATE}>{s}</span> : /Đã thực hiện/.test(s) ? <span className={TXT_OK}>{s}</span> : s;

const SchedulePage: React.FC = () => {
  const columns: WCol<LichRow>[] = [
    { title: 'Thời gian', render: (_, r) => <span className="whitespace-nowrap">{r.time}</span> },
    { title: 'Khách', render: (_, r) => <NameLink c={CUS[r.ma]} /> },
    { title: 'Mảng', render: (_, r) => CUS[r.ma].mang },
    { title: 'Loại', render: (_, r) => `${r.loai} · ${r.ten}` },
    { title: 'Phòng phụ trách', render: (_, r) => CUS[r.ma].phong },
    { title: 'Trạng thái', render: (_, r) => stCell(r.st) }
  ]
  const data = LICH.filter((r) => r.loai !== 'Tư vấn')

  return (
    <div className="space-y-3">
      <Cap title='Lịch thực hiện' items={['Vai trò: Telesales (xem) · Tư vấn cơ sở, kỹ thuật dùng ở app Lễ tân / Tư vấn cơ sở', 'Quy tắc: R36 · thao tác check-in, thực hiện thuộc đặc tả App Lễ tân / Tư vấn cơ sở (làm riêng)']} />
      <Demo />
      <Card>
        <Note className="!mt-0 mb-2">
          <>Bộ lọc: lịch loại Thực hiện và Tái khám của mọi khách. Đọc cùng bảng lịch hẹn với menu Lịch hẹn — không phải bảng riêng (R36).</>
        </Note>
        <DT columns={columns} data={data} />
      </Card>
    </div>
  )
};;

const TeleSchedule: React.FC = () => {
  const store = useStore();
  return (
    <StoreCtx.Provider value={store}>
      <Layout>
        <Helmet>
          <title>Lịch thực hiện | Khothi</title>
        </Helmet>
        <div className="relative flex min-h-0 flex-1">
          <div className="relative min-w-0 flex-1">
            <SchedulePage />
            <SoftBar />
          </div>
          <TeleDrawer />
        </div>
      </Layout>
    </StoreCtx.Provider>
  );
}

export default TeleSchedule;